/** Data Dictionary: meta_code is fewer than 5 characters, all caps. */
export const ROLE_META_CODE_MAX_LEN = 4;

function normalizeWords(roleName: string): string[] {
  return roleName
    .trim()
    .split(/[^a-zA-Z0-9]+/)
    .map((w) => w.replace(/[^a-zA-Z0-9]/g, ''))
    .filter(Boolean);
}

/** Build a base uppercase code (max 4 chars) from the role name. */
export function buildBaseRoleMetaCode(roleName: string): string {
  const words = normalizeWords(roleName);
  if (!words.length) return '';

  if (words.length === 1) {
    return words[0]!.toUpperCase().slice(0, ROLE_META_CODE_MAX_LEN);
  }

  let code = words.map((w) => w[0]!.toUpperCase()).join('');
  if (code.length < ROLE_META_CODE_MAX_LEN) {
    const first = words[0]!.toUpperCase();
    for (let i = 1; i < first.length && code.length < ROLE_META_CODE_MAX_LEN; i++) {
      code += first[i]!;
    }
  }
  return code.slice(0, ROLE_META_CODE_MAX_LEN);
}

/** Pick a unique code against existing meta codes from the API. */
export function suggestUniqueRoleMetaCode(roleName: string, existingCodes: Iterable<string>): string {
  const base = buildBaseRoleMetaCode(roleName);
  if (!base) return '';

  const existing = new Set(Array.from(existingCodes, (c) => c.trim().toUpperCase()).filter(Boolean));
  if (!existing.has(base)) return base;

  for (let n = 1; n <= 9; n++) {
    const suffix = String(n);
    const candidate = (base.slice(0, ROLE_META_CODE_MAX_LEN - suffix.length) + suffix).slice(0, ROLE_META_CODE_MAX_LEN);
    if (candidate && !existing.has(candidate)) return candidate;
  }

  for (let i = 0; i < 26; i++) {
    const letter = String.fromCharCode(65 + i);
    const candidate = (base.slice(0, ROLE_META_CODE_MAX_LEN - 1) + letter).slice(0, ROLE_META_CODE_MAX_LEN);
    if (candidate && !existing.has(candidate)) return candidate;
  }

  return base;
}
